/* global videojs */

import Swiper from 'swiper/dist/js/swiper.min';

$('.popup').each((index, element) => {
	let $component = $(element);
	let $slider = $component.find('.js-popup-slider');
	let $overlay = $component.find('.js-popup-overlay');
	let $closeButton = $component.find('.js-popup-close');
	let $page = $component.closest('.page');
	let $video = $component.find('.js-video');

	function pauseVideo(video) {
		if (!video.paused()) {
			video.pause();
		}
	}

	$component.on('popup:show', () => {
		$component.fadeIn(300);
	});

	$component.on('popup:hide', () => {
		$component.fadeOut(300);
	});

	if ($slider.length) {
		let slider = new Swiper($slider[0], {
			slidesPerView: 1,
			pagination: {
				el: '.swiper-pagination',
				type: 'bullets',
				clickable: true,
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
		});

		$component.on('popup:slide-to', (e, slideIndex) => {
			slider.slideTo(slideIndex, 0);
		});

		// popup analytics
		slider.on('slideChange', () => {
			ga('send', 'event', 'article', 'gallery popup change');
		});

		$video.each((idx, video) => {
			let isStarted = false;
			let articleName = $page.find('.article__title').text();
			let videoName = `видео в галерее статьи "${articleName}"`;
			let interval10sec;
			let markerList = null;

			let videoJs = videojs($(video)[0], {
				autoplay: true,
				controls: true,
				muted: true,
				fluid: false,
			});

			if ($page.data('page') === 'article-2') {
				markerList = [
					{
						'time': 54.0,
						'text': 'Тридевятое царство',
						'class': 'custom-marker',
					},
					{
						'time': 167.0,
						'text': 'Родина Алеши Поповича',
						'class': 'custom-marker',
					},
					{
						'time': 235,
						'text': 'Озеро Неро',
						'class': 'custom-marker',
					},
				];
			}

			if ($page.data('page') === 'article-1') {
				markerList = [
					{
						'time': 72.0,
						'text': 'Парк «Кудыкина гора»',
						'class': 'custom-marker',
					},
					{
						'time': 174.0,
						'text': 'Чайный домик',
						'class': 'custom-marker',
					},
					{
						'time': 278.0,
						'text': 'Город мастеров',
						'class': 'custom-marker',
					},
					{
						'time': 304.0,
						'text': 'Змей Горыныч',
						'class': 'custom-marker',
					},
				];
			}

			if ($page.data('page') === 'article-3') {
				markerList = [
					{
						'time': 78.0,
						'text': 'В гостях у Снегурочки',
						'class': 'custom-marker',
					},
					{
						'time': 204.0,
						'text': 'Родина Жар-птицы',
						'class': 'custom-marker',
					},
					{
						'time': 304.0,
						'text': 'Скатерть-самобранка',
						'class': 'custom-marker',
					},
				];
			}

			if (markerList) {
				videoJs.markers({
					markerStyle: {},
					markerTip: {
						display: false,
						text: (marker) => {
							return marker.text;
						},
					},
					onMarkerReached: (marker, id) => {
						$component.find('.custom-marker').eq(id).addClass('active');
					},
					markers: markerList,
				});

				$(window).on('load', () => {
					let markersArr = videoJs.markers.getMarkers();

					setTimeout(() => {
						$.each(markersArr, (id, marker) => {
							let $markerTooltip = $('<div/>', {
								'class': 'custom-marker__tooltip',
								'text': marker.text,
							});

							$component.find('.custom-marker').eq(id).append($markerTooltip);
						});
					}, 1000);
				});
			}

			let $startButton = $component.find('.vjs-big-play-button');

			$startButton.on('click', () => {
				let articleTitle = $page.find('.article__title').text();

				ga('send', 'event', 'article', 'video click', `видео в статье "${articleTitle}"`);
			});

			// article video analytics
			videoJs.on('play', () => {
				if (!isStarted) {
					isStarted = true;
					ga('send', 'event', 'video', 'play', videoName, {nonInteraction: true});
					ga('rbcspec.send', 'event', 'video', 'play', {nonInteraction: true});
				}

				if (!interval10sec) {
					interval10sec = setInterval(() => {
						if (!video.paused()) {
							ga('send', 'event', 'video', 'timing 10s', videoName, 10);
							ga('rbcspec.send', 'event', 'video', 'timing 10s', '', 10);
						}
					}, 10000);
				}
			});

			videoJs.on('pause', () => {
				if (interval10sec) {
					clearInterval(interval10sec);
				}
			});

			videoJs.on('ended', () => {
				ga('send', 'event', 'video', 'finish', videoName);
				ga('rbcspec.send', 'event', 'video', 'finish');

				if (interval10sec) {
					clearInterval(interval10sec);
				}
			});

			$component.on('popup:hide', () => {
				pauseVideo(videoJs);
			});

			slider.on('slideChange', () => {
				pauseVideo(videoJs);
			});

			$page.on('page:hide', () => {
				pauseVideo(videoJs);
			});
		});

		$component.on('popup:show', () => {
			slider.update();
		});

		$page.on('page:show', () => {
			slider.update();
		});
	}

	$closeButton.on('click', () => {
		$component.trigger('popup:hide');
	});

	$overlay.on('click', () => {
		$component.trigger('popup:hide');
	});

	$page.on('page:hide', () => {
		$component.trigger('popup:hide');
	});
});
